import React from 'react';
import { Link } from 'gatsby';
import styles from '../styles/components/pageTitle.module.scss';

export interface PageTitleProps {
    headerClassName: string | undefined;
}

export default class PageTitle extends React.Component<PageTitleProps, {}> {
    public render() {
        const component =
            <h1 className={this.props.headerClassName}>
                <Link to='/' className={styles.title}>
                    Kyle Buzby
                </Link>
            </h1>;
        return component;
    }
}
